import {sensorsTableMap} from "../constants/sensors-constants";

export default {
    data() {
        return {
            defaultTab: 1,
            activeTab: 1,
            profileTab: 5
        }
    },
    watch: {
        $route: {
            handler: function (to) {
                if (to.name === 'profile') {
                    this.activeTab = this.profileTab;
                } else {
                    this.activeTab = sensorsTableMap[to.query.tab] || this.defaultTab;
                }
            },
            deep: true,
            immediate: true
        }
    }
};